<template>
  <div>
    <div class="text-xs-center" v-if="verifyingToken">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <v-card class="elevation-12" v-if="!verifyingToken">
      <v-toolbar color="white" dense>
        <img src="@/assets/logo.jpg" height="36px" width="200px" class="mr-3" />
        <v-icon color="primary">person</v-icon>
        <v-toolbar-title>Password Reset</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-progress-linear
          v-show="connecting"
          :indeterminate="true"
        ></v-progress-linear>
        <v-alert v-model="error" type="error" dismissible icon="warning" dark>
          {{ errorText }}
        </v-alert>
        <v-text-field
          :disabled="connecting"
          name="password"
          label="Enter new password"
          v-model="password"
          :rules="passwordRules"
          required
          prepend-icon="vpn_key"
          @keyup.enter="submit"
          :append-icon="passwordVisibilityOff ? 'visibility' : 'visibility_off'"
          :append-icon-cb="
            () => (passwordVisibilityOff = !passwordVisibilityOff)
          "
          :type="passwordVisibilityOff ? 'password' : 'text'"
        >
        </v-text-field>
        <v-text-field
          :disabled="connecting"
          name="confirmPassword"
          label="Confirm new password"
          v-model="confirmPassword"
          :rules="[
            () => !!confirmPassword || 'Required',
            confirmPassword === password || 'Passwords don\'t match'
          ]"
          required
          prepend-icon="vpn_key"
          @keyup.enter="submit"
          :append-icon="
            confirmPasswordVisibilityOff ? 'visibility' : 'visibility_off'
          "
          :append-icon-cb="
            () => (confirmPasswordVisibilityOff = !confirmPasswordVisibilityOff)
          "
          :type="confirmPasswordVisibilityOff ? 'password' : 'text'"
        >
        </v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-btn
          @click="submit"
          round
          color="primary"
          :disabled="!valid || connecting"
        >
          Reset Password
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<style scoped>
/*#sign-in-card {
      position: absolute;
      right: 15px;
      top: 85px;
      width: 30%;
  }*/
</style>
<script type="text/javascript">
export default {
  name: 'NewResetPassword',
  props: ['token'],
  data() {
    return {
      passwordVisibilityOff: true,
      verifyingToken: true,
      confirmPasswordVisibilityOff: true,
      error: null,
      errorText: '',
      email: '',
      emailRules: [v => !!v || 'Username is required'],
      password: '',
      confirmPassword: '',
      passwordRules: [v => !!v || 'Password is required'],
      connecting: false
    }
  },
  computed: {
    valid() {
      return (
        this.password &&
        this.confirmPassword &&
        this.confirmPassword === this.password
      )
    }
  },
  methods: {
    verifyToken() {
      let that = this
      that.axios
        .get('password/find/' + this.token)
        .then(response => {
          //
          that.email = response.data.email
        })
        .catch(error => {
          that.$app.log(error)
          that.$router.push({
            name: 'passwordReset',
            params: { message: error.response.data.message }
          })
        })
        .then(() => {
          that.verifyingToken = false
        })
    },
    submit() {
      // Native form submission is not yet supported
      this.error = false
      this.connecting = true
      let that = this
      this.$app.log(
        `Password = ${this.password} and confirmPassword = ${this.confirmPassword}`
      )
      this.axios
        .post('password/reset', {
          email: this.email,
          password: this.password,
          password_confirmation: this.confirmPassword,
          token: this.token
        })
        .then(function(response) {
          that.connecting = false
          that.$notify({
            group: 'all',
            title: 'Password reset',
            text: 'You have successfully reset your password!'
          })
          that.$router.push({
            name: 'signIn',
            params: {}
          })
        })
        .catch(function(error) {
          that.error = true
          that.connecting = false
          if (error.code === 404) {
            that.errorText = error.response.data.message
          } else {
            that.errorText = 'An error occurred ' + error.message
          }
        })
    }
  },
  mounted() {
    this.verifyToken()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewResetPassword.vue